import React from "react";
import delivered from "../../../../assets/images/dashboard/icon/delivered.png";
import pending from "../../../../assets/images/dashboard/icon/pending.png";
import paid from "../../../../assets/images/dashboard/icon/paid.png";
import formateText from "../../../../utils/Formate";

const UserBookingRemaining = ({ id, name, value, total, loading }) => {
  const icon = [delivered, pending, paid];
  
  if (loading) {
    return (
      <div className="bg-gradient-to-tr min-h-[160px] from-[#E6F7F3] to-[#FAEBE9] rounded-lg shadow-xl w-full p-3 animate-pulse">
        <div className="flex overflow-hidden w-full justify-between items-start gap-11">
          <div>
            <div className="h-6 w-24 bg-gray-300 rounded mb-4"></div>
            <div className="h-12 w-16 bg-gray-300 rounded"></div>
          </div>
          <div className="w-[50px] h-[50px] bg-gray-300 rounded"></div>
        </div>
      </div>
    );
  }

  return (
    <div className="bg-gradient-to-tr min-h-[160px] from-[#E6F7F3] to-[#FAEBE9] rounded-lg shadow-xl w-full p-3">
      <div className="flex overflow-hidden w-full justify-between items-start gap-11">
        <div>
          <h1 className="text-lg font-medium">{formateText(name)}</h1>
          <h1 className={`${name==="Paid"?"text-2xl xl:text-6xl":"text-6xl"} mt-3 font-semibold`}>
            {value}
          </h1>
          {total > 0 && (
            <p className="text-sm text-gray-600 mt-1">
              {Math.round((value / total) * 100)}% of total ({value}/{total})
            </p>
          )}
        </div>
        <img className="w-[50px] object-contain" src={icon[id - 1]} alt="" />
      </div>
      <div className={name === "Paid" ? "hidden" : "flex items-center gap-8 mt-3"}>
        <span className="font-bold">{Math.round((value / total) * 100)}%</span>
        <div className="relative w-full border border-b-8 border-gray-200 rounded-full">
          <div
            style={{ width: `${(value / total) * 100}%` }}
            className="absolute top-0 left-0 border border-b-4 border-green-600 rounded-full"
          ></div>
        </div>
        <span className="font-bold">{value}/{total}</span>
      </div>
    </div>
  );
};

export default UserBookingRemaining;